import { authenticatedAjax, REQUEST } from "../../../../config/ajax-wrapper";
import fileDownload from "js-file-download";
import { AnyAction } from "redux";
import {
    AGRUPADORAS_ENVIAR,
    AGRUPADORAS_DESCARGAR_PLANTILLA,
    AGRUPADORAS_ENVIO_EXITOSO,
    AGRUPADORAS_ERROR_ENVIO,
    AGRUPADORAS_PLANTILLA_OBTENIDA,
    AGRUPADORAS_ERROR_OBTENIENDO_PLANTILLA,
    errorAutorizacion,
    errorEnvio,
    envioExito,
    plantillaObtenida,
    errorObteniendoPlantilla
} from "../modulos/actions";

export const enviarAgrupadorasEpic = action$ =>
    action$.ofType(AGRUPADORAS_ENVIAR)
        .mergeMap((action: any) => {

            const url = `parametros/agrupadoras/enviar-parametros`;

            return authenticatedAjax
                .upload(
                    url,
                    action.archivoEnvio
                )
                .map((response) => {
                    console.log(response);
                    
                    return envioExito();
                }).catch(response => {
                    if (response.status === 401 || response.status === 403) {
                        return [errorAutorizacion()];
                    } else {
                        
                        return [errorEnvio()];
                    }
                });
        });

export const descargarPlantillaAgrupadorasEpic = action$ =>
    action$.ofType(AGRUPADORAS_DESCARGAR_PLANTILLA)
        .mergeMap((action: any) => {

            const url = `parametros/descargar-plantilla-agrupadoras`;

            return authenticatedAjax
                .getBlob(url)
                .map((response) => {
                    const data = response.response;
                    fileDownload(
                        data,
                        "plantilla_empresas_agrupadoras.xlsx",
                        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                    );
                    return plantillaObtenida();
                }).catch(response =>
                    [errorObteniendoPlantilla()]
                );
        });

export const envioAgrupadorasReducer = (state =
    {
        estadoEnvio: REQUEST.NONE,
        mensajeUsuario: undefined
    }, action: AnyAction) => {

    switch (action.type) {

        case AGRUPADORAS_ENVIAR:
            return {
                ...state,
                estadoEnvio: REQUEST.PENDING
            };
        case AGRUPADORAS_ENVIO_EXITOSO:
            return {
                ...state,
                estadoEnvio: REQUEST.SUCCESS
            };
        case AGRUPADORAS_ERROR_ENVIO:
            return {
                ...state,
                estadoEnvio: REQUEST.ERROR,
                mensajeUsuario: action.mensajeRespuesta
            };
        case AGRUPADORAS_PLANTILLA_OBTENIDA:
        case AGRUPADORAS_ERROR_OBTENIENDO_PLANTILLA:
            return { ...state };
        default:
            return state;
    }
};





// WEBPACK FOOTER //
// ./src/co/sura/dominio/parametros/cargar_parametros/modulos/reducers.ts